import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import Header from './Header';
import Footer from './Footer';
import { Helmet } from "react-helmet";

function Blog() {
  const [BlogList, setBlogData] = useState([]);
  const [activitydatas, setActivityDatas] = useState(null);
  const [loading, setLoading] = useState(true);
  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20); // Show 8 items per page (2 rows of 4)

useEffect(() => {
  Promise.all([
    fetch("https://planjourneysglobal.com/admin/api/home_page/banners/blog")
      .then(res => res.json()),
    fetch("https://planjourneysglobal.com/admin/api/blogs")
      .then(res => res.json())
  ])
    .then(([bannerRes, blogRes]) => {
      setActivityDatas(bannerRes.data?.[0] || null);
      setBlogData(blogRes.data || []);
      setLoading(false);
    })
    .catch(err => {
      console.log(err);
      setLoading(false);
    });
}, []);
  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = BlogList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(BlogList.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0); // Scroll to top on page change
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo(0, 0);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      window.scrollTo(0, 0);
    }
  };

  return (
    <>
      <Helmet>
        <title>{activitydatas?.meta_title}</title>
        <meta
          name="description"
          content={activitydatas?.meta_discription}
        />
        {activitydatas?.meta_keyword && (
          <meta name="keywords" content={activitydatas.meta_keyword} />
        )}
        {activitydatas?.slug && (
          <link
            rel="canonical"
            href={`https://planjourneysglobal.com/${activitydatas.slug}`}
          />
        )}
        <meta property="og:title" content={activitydatas?.meta_title} />
        <meta
          property="og:description"
          content={activitydatas?.meta_discription}
        />
        {activitydatas?.image_url && (
          <meta property="og:image" content={activitydatas.image_url} />
        )}
        {activitydatas?.slug && (
          <meta
            property="og:url"
            content={`https://planjourneysglobal.com/${activitydatas.slug}`}
          />
        )}
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content={activitydatas?.meta_title} />
        <meta
          name="twitter:description"
          content={activitydatas?.meta_discription}
        />
        {activitydatas?.image_url && (
          <meta name="twitter:image" content={activitydatas.image_url} />
        )}
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <Header />
      
      {/* Start Breadcrumb section */}
      <div
        className="breadcrumb-section"
        style={{
          backgroundImage: activitydatas?.image_url
            ? `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${activitydatas.image_url})`
            : "none"
        }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{activitydatas?.banner_name} </h1>
          </div>
        </div>
      </div>
      {/* End Breadcrumb section */}

      {activitydatas?.short_discription?.trim() && (
        <div className="container">
          <div
            className="row justify-content-center mb-10 mt-30 wow animate fadeInDown"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
          >
            <div className="col-lg-6">
              <div className="section-title text-center">
                <div
                  dangerouslySetInnerHTML={{
                    __html: activitydatas.short_discription
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Travel Inspiration Page Start*/}
      <div className="travel-inspiration-page pt-100 mb-100 mt-10">
        <div className="container">
          <div className="row gy-md-4 gy-0 mb-60">
            {currentItems.map((item, index) => (
              <div
                className="col-lg-3 col-md-3 wow animate fadeInDown"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                key={index}
              >
                <div className="blog-card2 two">
                  <div className="blog-img-wrap">
                    <Link to={`/blog/${item.slug}`} className="blog-img">
                      <img src={item.home_image_url} alt={item.blog_name} />
                    </Link>
                    <Link to={`/blog/${item.slug}`} className="location">
                      <svg
                        width={14}
                        height={14}
                        viewBox="0 0 14 14"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6.83615 0C3.77766 0 1.28891 2.48879 1.28891 5.54892C1.28891 7.93837 4.6241 11.8351 6.05811 13.3994C6.25669 13.6175 6.54154 13.7411 6.83615 13.7411C7.13076 13.7411 7.41561 13.6175 7.6142 13.3994C9.04821 11.8351 12.3834 7.93833 12.3834 5.54892C12.3834 2.48879 9.89464 0 6.83615 0ZM7.31469 13.1243C7.18936 13.2594 7.02008 13.3342 6.83615 13.3342C6.65222 13.3342 6.48295 13.2594 6.35761 13.1243C4.95614 11.5959 1.69584 7.79515 1.69584 5.54896C1.69584 2.7134 4.00067 0.406933 6.83615 0.406933C9.67164 0.406933 11.9765 2.7134 11.9765 5.54896C11.9765 7.79515 8.71617 11.5959 7.31469 13.1243Z" />
                        <path d="M6.83618 8.54529C8.4624 8.54529 9.7807 7.22698 9.7807 5.60077C9.7807 3.97456 8.4624 2.65625 6.83618 2.65625C5.20997 2.65625 3.89166 3.97456 3.89166 5.60077C3.89166 7.22698 5.20997 8.54529 6.83618 8.54529Z" />
                      </svg>
                      {item.category}
                    </Link>
                  </div>
                  <div className="blog-content">
                    <Link to={`/blog/${item.slug}`} className="blog-date">
                      {item.created_at}
                    </Link>
                    <h4>
                      <Link to={`/blog/${item.slug}`}>
                        {item.blog_name}
                      </Link>
                    </h4>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination Start */}
          {BlogList.length > itemsPerPage && (
            <div className="pagination-area mt-60 wow animate fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
              <div className="paginations-button">
                <a 
                  href="#" 
                  onClick={(e) => { e.preventDefault(); handlePrev(); }}
                  style={{ opacity: currentPage === 1 ? 0.5 : 1, pointerEvents: currentPage === 1 ? 'none' : 'auto' }}
                >
                  <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                    <g>
                      <path d="M7.86133 9.28516C7.14704 7.49944 3.57561 5.71373 1.43276 4.99944C3.57561 4.28516 6.7899 3.21373 7.86133 0.713728" strokeWidth="1.5" strokeLinecap="round"></path>
                    </g>
                  </svg>
                  Prev
                </a>
              </div>
              <ul className="paginations">
                {[...Array(totalPages)].map((_, i) => (
                  <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                    <a href="#" onClick={(e) => { e.preventDefault(); handlePageChange(i + 1); }}>
                      {String(i + 1).padStart(2, '0')}
                    </a>
                  </li>
                ))}
              </ul>
              <div className="paginations-button">
                <a 
                  href="#" 
                  onClick={(e) => { e.preventDefault(); handleNext(); }}
                  style={{ opacity: currentPage === totalPages ? 0.5 : 1, pointerEvents: currentPage === totalPages ? 'none' : 'auto' }}
                >
                  Next
                  <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                    <g>
                      <path d="M1.42969 9.28613C2.14397 7.50042 5.7154 5.7147 7.85826 5.00042C5.7154 4.28613 2.50112 3.21471 1.42969 0.714705" strokeWidth="1.5" strokeLinecap="round"></path>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          )}
          {/* Pagination End */}

        </div>
      </div>
      {/*Travel Inspiration Page End*/}

      <Footer />
    </>
  );
}

export default Blog;